import { cva } from 'class-variance-authority';
import styles from '../styles.module.scss';

export const viewItemFieldVariants = cva(styles.item, {
  variants: {
    direction: {
      column: styles.column,
      row: styles.row,
    },
  },
  defaultVariants: {
    direction: 'column',
  },
});
